module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_ys30@2x.04d0df31.png";